import { graphql, type GraphQLTaggedNode } from 'react-relay/legacy.js';

export const designSeriesRoot: GraphQLTaggedNode = graphql`
    query designSeriesRootQuery(
        $designSeriesName: String = ""
        $primaryCreatorDesignsMaxCount: Int = 6
    ) {
        viewer {
            iconicDesignSeriesPage(designSeriesName: $designSeriesName) {
                cmsTopModule {
                    title
                    mainImage
                }
                primaryCreator(maxDesignsCount: $primaryCreatorDesignsMaxCount) {
                    displayName
                }
            }
            ...DesignSeriesLayout_viewer
        }
    }
`;
